export const titleDefaults = {
    applications: "Applicaties",
    notifications: "Notificaties",
    profile: "Profiel",
};
export default titleDefaults;
